import React from 'react'

import * as S from '../styles'

interface InvalidCardNumberProps {
  cardNumber?: string
  customTitle?: string
  customMessage?: string
}

export const InvalidCardNumber = ({
  cardNumber,
  customTitle,
  customMessage
}: InvalidCardNumberProps): JSX.Element => {
  const defaultTitle = cardNumber
    ? `Não conseguimos validar sua carteirinha de número ${cardNumber}`
    : 'Por favor, tente novamente'

  const defaultMessage = cardNumber
    ? 'Verifique se ela está correta e entre em contato com a nossa equipe de atendimento pelo chat.'
    : 'Verifique os dados preenchidos e tente novamente.'

  return (
    <>
      <S.StyledErrorIcon />
      <S.Title >
        {customTitle || defaultTitle}
      </S.Title>
      <S.Text variant='content2'>
        {customMessage || defaultMessage}
      </S.Text>
    </>
  )
}
